import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "size", "selected", "showArrow", "disabled", "expanded", "background", "tagName", "data-event-name"];
import PropTypes from 'prop-types';
import React, { isValidElement } from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import Icon from '../Icon';
import Label from '../Label';
import ConfigConsumer from '../ConfigConsumer'; // 下拉菜单选项

export default function DropdownOption(_ref) {
  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      selected = _ref.selected,
      showArrow = _ref.showArrow,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      background = _ref.background,
      TagName = _ref.tagName,
      trackEventName = _ref['data-event-name'],
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    size: size
  }, function (_ref2) {
    var configSize = _ref2.size;
    return /*#__PURE__*/React.createElement(TagName, _extends({
      "data-event-name": trackEventName,
      "data-event-content": true,
      className: classNames('jmtd-dropdown-option', className, {
        'jmtd-dropdown-option-large': configSize === 'large',
        'jmtd-dropdown-option-small': configSize === 'small',
        'jmtd-dropdown-option-mini': configSize === 'mini',
        'jmtd-dropdown-option-expanded': expanded,
        'jmtd-dropdown-option-selected': selected,
        'jmtd-dropdown-option-disabled': disabled,
        'jmtd-dropdown-option-has-arrow': showArrow
      })
    }, other), background, /*#__PURE__*/React.createElement("div", {
      className: "jmtd-dropdown-content"
    }, /*#__PURE__*/isValidElement(children) ? children : /*#__PURE__*/React.createElement(Label, {
      theme: "light"
    }, children)), showArrow && /*#__PURE__*/React.createElement(Icon, {
      width: 14,
      className: "jmti-angle-right jmtd-dropdown-arrow"
    }));
  });
}
DropdownOption.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  selected: PropTypes.bool,
  showArrow: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  background: PropTypes.node,
  tagName: PropTypes.elementType,
  'data-event-name': PropTypes.string
};
DropdownOption.defaultProps = {
  className: '',
  children: null,
  size: null,
  selected: false,
  showArrow: false,
  disabled: false,
  expanded: false,
  background: null,
  tagName: 'div',
  'data-event-name': 'click'
};